import { render } from "./ResidentialSidebar.vue?vue&type=template&id=2c07c4dd&ts=true"
import script from "./ResidentialSidebar.vue?vue&type=script&lang=ts"
export * from "./ResidentialSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__